<template>
    <router-link :to="{name:'coachitem',params: { coachId: coachInfo.coachId}}" class="avatar-card tac">
        <div class="avatar-card__pic">            
            <span v-if="coachInfo.avatar"><img :src="coachInfo.avatar"></span>  <!-- 后台上传头像 -->
            <span v-else-if="coachInfo.avatar==''"><img :src="coachInfo.user.largeAvatar"></span>   <!-- 用户头像 -->
            <span v-else><img src="https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3036298910,569278160&fm=27&gp=0.jpg" alt=""></span>
            <i v-if="coachInfo.user.isVip == 1" class="avatar-card__level iconfont">&#xe634;</i>
        </div>
        <div class="fs2 mtn c4 avatar-card__uname">{{ coachInfo.realName }}</div>
        <!-- <div class="fs1 c9 mtn clear">
            <van-rate class="" v-model="rateNum" :size="13" disabled-color="#FF6F0F" disabled />
        </div> -->
        <div class="c9 fs1 mtn avatar-card__dis">{{ coachInfo.title | titleFilter}}</div>
    </router-link>
</template>
<script>
import Vue from 'vue';
import { Rate } from 'vant';
Vue.use(Rate);
export default {
    name: 'AvatarCard',
    props: {
      coachInfo: {  // 教练信息
        type: Object
      }
    },
    filters: {
        titleFilter(status) {
        // 教练职称
        const statusMap = {
            assistant: '助教',
            junior: '初级教练',
            intermediate: '中级教练',
            senior: '高级教练'
        }
        return statusMap[status]
        }
    },
    computed:{
        rateNum(){
            if(this.coachInfo.rating == '' || this.coachInfo.rating==0){
                return 5
            }else{
                return this.coachInfo.rating
            }
        }
    }
}
</script>
<style lang="less">
.avatar-card{
    display: block;
    height: 1.5rem;
    padding: .1rem .1rem;
    margin-top: .1rem;
    box-shadow: rgba(0,0,0,.2) 0 0 .05rem;
    &__pic{
        position: relative;
        width: .6rem;
        height: .6rem;
        margin: 0 auto;
        &>span{
            display: block;
            width: .5rem; height: .5rem;
            margin: .1rem auto 0;
            border-radius: 50%;
            overflow: hidden;
            &>img{
                width: 100%; height: 100%;
                object-fit: cover;
                filter: blur(0px);
            }
        }
    }
    &__uname{
        white-space: nowrap;
        overflow: hidden;
    }
    &__level{
        position: absolute;
        right: .04rem;bottom: .04rem;
        width: .22rem;height: .22rem; line-height: .22rem;
        color: #FFA800;
        font-size: .18rem;
        border-radius: 50%;
        background-color: white;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarCard.vue